
















































































import TheTemplateM from "@/general/components/templates/TheTemplateM.vue";
import InputText from "@/common/components/atoms/InputText.vue";
import InputSelect from "@/common/components/atoms/InputSelect.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import FormLabel from "@/common/components/organisms/FormLabel.vue";
import ValidationErrorText from "@/common/components/atoms/ValidationErrorText.vue";
import { extend, ValidationProvider, ValidationObserver } from "vee-validate";
import { required, max } from "vee-validate/dist/rules";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import {
  putPasswordReminder,
  getPasswordReminder,
  getSecretQuestions
} from "@/general/store/api";
import commons from "@/common/store/modules/commons";
import AuthStorage from "@/general/utils/auth";

extend("required", {
  ...required,
  message: "{_field_}を入力してください。"
});
extend("max", {
  ...max,
  message: "{_field_}は{length}文字以内を入力してください。"
});

@Component({
  components: {
    TheTemplateM,
    InputText,
    InputSelect,
    ButtonMain,
    FormLabel,
    ValidationErrorText,
    ValidationProvider,
    ValidationObserver
  }
})
export default class SecrateQuestion extends Vue {
  @Prop({ type: Number, default: 1 }) id!: number;
  formData: any = [];

  secretQuestion!: any;
  secretQuestionOptions: any = [];
  secretAnswer = "";

  breadcrumb = [
    {
      text: "",
      url: "/home",
      pageType: "home"
    },
    {
      text: "マイページ",
      url: "/my-page",
      pageType: "lower"
    },
    {
      text: "秘密の質問変更",
      url: "",
      pageType: "lower"
    }
  ];

  submit(ObserverProps: any) {
    ObserverProps.passes(() => {
      this.$refs.form as Vue & { submit: () => any };
    });
  }

  get passwordReminder() {
    return {
      id: 1,
      user: 1,
      question: this.secretQuestion,
      answer: this.secretAnswer
    };
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    const response = await getPasswordReminder(this.id);
    this.formData = response;
    this.secretQuestion = this.formData.question;
    this.secretAnswer = this.formData.answer;

    const secretQuestions = await getSecretQuestions();
    this.secretQuestionOptions = secretQuestions.results?.map(res => {
      return { value: res.id, label: res.question };
    });
    this.secretQuestionOptions.unshift({ value: "", label: "" });
    await commons.getBreadcrumb(this.breadcrumb);
  }
  async submitAnswer() {
    console.log("...inside submit");
    const response = await putPasswordReminder(this.id, this.passwordReminder);
    this.formData = response;
    window.location.href = "/my-page/secretQuestionUpdated.html";
  }
}
